export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/9087b38339b011a3e90dfeb23d2afa2c/847f811fe4a76d85a774e45ed17c6cbd.jpeg"
          alt="Gallery Pizza hero background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/70 via-[#1A1A1A]/50 to-[#1A1A1A]/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-12 flex flex-col items-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#FAF8F5]/30 bg-[#FAF8F5]/10 backdrop-blur-sm rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 flex items-center justify-center">
            <span className="block w-1.5 h-1.5 rounded-full bg-[#FF6B35]" />
          </span>
          <span className="text-[#FAF8F5] text-xs font-semibold tracking-[0.2em] uppercase">
            Landvegamót &bull; South Iceland
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-[#FAF8F5] font-extrabold text-4xl md:text-6xl lg:text-7xl leading-tight mb-4 max-w-4xl">
          One of the Best Pizza Stop
          <br />
          <span className="text-[#FF6B35]">in South Iceland</span>
        </h1>

        {/* Subheadline */}
        <p className="text-[#FAF8F5]/75 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed">
          Fresh handmade pizza, burgers, fish &amp; chips, The perfect stop on your South Iceland journey.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => handleScroll("#menu")}
            className="bg-[#FF6B35] text-[#1A1A1A] font-bold text-sm px-8 py-4 rounded-full hover:bg-[#e55a24] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap tracking-wider uppercase"
          >
            View Menu
          </button>
          <a
            href="https://maps.google.com/?q=Landvegamót,+Hella,+Iceland"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-[#FAF8F5]/50 text-[#FAF8F5] font-bold text-sm px-8 py-4 rounded-full hover:bg-[#FAF8F5]/10 transition-all duration-300 cursor-pointer whitespace-nowrap tracking-wider uppercase flex items-center gap-2"
          >
            <i className="ri-map-pin-line" />
            Get Directions
          </a>
        </div>

        {/* Rating */}
        <div className="mt-12 flex items-center gap-6 flex-wrap justify-center">
          <div className="flex items-center gap-2">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-[#FF6B35] text-sm" />
              ))}
            </div>
            <span className="text-[#FAF8F5]/80 text-sm font-medium">4.8 on Google</span>
          </div>
          <div className="w-px h-4 bg-[#FAF8F5]/20" />
          <span className="text-[#FAF8F5]/60 text-sm">Loved by travelers and locals since opening</span>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-[#FAF8F5]/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-[#FAF8F5]/40 text-lg" />
      </div>
    </section>
  );
}
